import script from "./ContractDocumentView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContractDocumentView.vue?vue&type=script&setup=true&lang=ts"

import "./ContractDocumentView.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__